import { requestApi } from "../funcitons";

export const FormFieldsQueries = {
    createFormField: async (cellId, name, type) => {
        const res = await requestApi('cells/form-fields', 'POST', { form_cell_id: cellId, name, type });
        return res.data;
    },
    updateFormField: async (id, name, type) => {
        const res = await requestApi('cells/form-fields/' + id, 'PUT', { name, type });
        return res.data;
    },
    deleteFormField: async (id) => {
        const res = await requestApi('cells/form-fields/' + id, 'DELETE');
        return res.data;
    },
}

export const FormFieldOptionsQueries = {
    createFormFieldOption: async (formFieldId, value, label) => {
        const res = await requestApi('cells/form-field-options', 'POST', { form_field_id: formFieldId, value, label });
        return res.data;
    },
    updateFormFieldOption: async (id, value, label) => {
        const res = await requestApi('cells/form-field-options/' + id, 'PUT', { value, label });
        return res.data;
    },
    deleteFormFieldOption: async (id) => {
        const res = await requestApi('cells/form-field-options/' + id, 'DELETE');
        return res.data;
    },
}